module.exports = __webpack_public_path__ + "img/machinegun.3c563288.webp";